import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { Ano } from './../../consulta/distribuicao-mensal-aos-municipio/shared/model/distribuicaoMensalMunicipio.model';
import { ConciliacaoDistribuicaoMunicipioService } from './shared/service/conciliacao-distribuicao-municipio.service';
import { ConciliacaoDistribuicaoMunicipioModelView } from './shared/model/conciliacao-distribuicao-municipio.model';
import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';

@Component({
  selector: 'sarf-consulta-ipva',
  templateUrl: './consulta-ipva.component.html'
})

export class ConsultaIpvaComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  DataInicio: Date;
  showFile: ShowFile;
  exibirGrid:boolean = false;
  _dadosConciliacao: ConciliacaoDistribuicaoMunicipioModelView;
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  

  constructor(

    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages,
    private readonly _conciliacaoDistribuicao : ConciliacaoDistribuicaoMunicipioService
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
  }

  formConsultaIpva = new FormGroup({
    DataInicio: new FormControl('DataInicio', Validators.required),
  });

  ngOnInit() {
    
 
  }

consultarDadosIPVA(modal: AslibModalComponent){
this._aslibLoadingService.start();
  this.subscription =  this._conciliacaoDistribuicao.consultarDistribuicaoIPVA(this.DataInicio)
      .subscribe( result => {
        if(result.objetoMensagem.Tipo == 'Alerta'){
          this.exibirGrid = false;
          this.modalManagerHelper.modalMensagem(modal, result.objetoMensagem);
        }else{
          this.exibirGrid = true;
          this._dadosConciliacao = result;
        }
        
      },
      () => {
       this.unSubscribe();
      });
  }

   public limparConsulta(){
      this.DataInicio = null;
      this.exibirGrid = false;
        this._dadosConciliacao = null;
    }

     gerarRelatorio(tipoFile: number) {
          
          this._aslibLoadingService.start();
          this.subscription = this._conciliacaoDistribuicao
            .gerarRelatoriodeIpva(this.DataInicio).subscribe(
              data => {
                this.showFile.Windows(data,ExportTypes.Excel_xls,'RelatorioDistribuicaoIPVA');
              },
              (error: any) => {
                this._aslibLoadingService.complete();
                new AslibModalComponent(this._aslibModalService).open({
                  title: 'ERRO',
                  text: this._messages.MN0011,
                  type: 'erro'
                });
              },
              () => {
               this.unSubscribe();
              }
            );
          }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ipva/consulta-ipva/consulta-ipva.component.ts